/**
 * 开关控制组件（ControlSwitch）
 */

import type { ReactElement } from 'react'
import { Switch } from '@/components/ui/switch'
import { cn } from '@/lib/utils'
import type { FormFieldProps } from './types'

/**
 * 开关控制组件
 * @param props 组件属性
 * @returns 组件元素
 */
export function ControlSwitchField({
  component,
  value,
  onChange,
  error,
  disabled = false,
}: FormFieldProps): ReactElement {
  const checked = typeof value === 'boolean' ? value : Boolean(component.default_value)

  /**
   * 处理开关变化
   * @param newValue 新的开关值
   */
  function handleChange(newValue: boolean): void {
    onChange(newValue)
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium">
          {component.title}
          {component.is_required && (
            <span className="ml-1 text-destructive">*</span>
          )}
        </label>
        <Switch
          checked={checked}
          onCheckedChange={handleChange}
          disabled={disabled}
          className={cn(
            disabled && 'cursor-not-allowed opacity-50'
          )}
        />
      </div>
      {error !== undefined && (
        <p className="text-xs text-destructive">{error}</p>
      )}
    </div>
  )
}
